var SliderBlog = function () {
	
	this.init = function () {
		$('.btn-download').click(function(e){
			e.preventDefault();
			window.dataLayer.push({'event':'EventoSimples', 'gacategoria': 'Mobil™-Club-Brasil', 'garotulo': 'Baixar', 'gaacao': 'click'});
			
			if($('#isMemberLogged').val() == "false"){
				$('#login-form').css('display', 'none');
				$('#esqueci-senha-form').css('display', 'none');
				$('#esqueci-senha-confirmacao').css('display', 'none');
				$('#cadastro-form').css('display', 'none');
				$('#cadastro-confirmacao').css('display', 'none');
				$('#perfil-form').css('display', 'none');
				$("#perfil-confirmacao").css("display", "none");
				$("#modal-login").css("display", "block");
				$('#modal-header').open();
			}else{
				window.open(
					$(this).data('link'),
					'_blank'
				  );
			}
		});
		

		$('.slider-blog').slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			arrows: true,
			dots: false,
			responsive: [
				{
				  breakpoint: 992,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
					dots: true
				  }
				},
			]
		});	
	}

	return this.init();
}